import styled from 'styled-components'
import { colors } from '../../../../Themes/colors'

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  padding: 16px;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;

  display: ${({ show }) => (show ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;

  section {
    background-color: #fff;
    width: 432px;
    max-width: 432px;
    margin: auto;
    padding: 24px;
    border-radius: 8px;
    color: ${colors.gray};
    @media (max-width: 500px) {
      width: 328px;
    }
  }

  div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
  }

  h1 {
    font-size: 18px;
    line-height: 26px;
  }

  button {
    border: none;
    background-color: transparent;
  }

  p {
    font-size: 16px;
    line-height: 24px;
    color: #424242;
  }
`
export const Content = styled.main`
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  p {
    padding: 16px 0 32px 0;
    font-size: 14px;
    line-height: 24px;
    color: #424242;
  }
`
